import { render, staticRenderFns } from "./StockviewPercentageBreakdown.vue?vue&type=template&id=3939f47a&scoped=true&"
import script from "./StockviewPercentageBreakdown.vue?vue&type=script&lang=js&"
export * from "./StockviewPercentageBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./StockviewPercentageBreakdown.vue?vue&type=style&index=0&id=3939f47a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3939f47a",
  null
  
)

export default component.exports